import * as TYPES from './mutationTypes'
import Cookies from 'js-cookie'

export default {
  // device
  [TYPES.TOGGLE_DEVICE](state, device) {
    state.device = device
  },
  // 面包屑
  [TYPES.BREADLISTADD](state, obj) {
    state.breadListState.push(obj)
  },
  [TYPES.BREADLISTREMOVE](state, num) {
    state.breadListState.splice(num, state.breadListState.length - num)
  },
  [TYPES.BREADLISTSET](state, arr) {
    state.breadListState = arr
  },
  // 用户信息
  [TYPES.USERINFO_UPDATE](state, userInfo) {
    state.userInfo = userInfo
  },
  [TYPES.USERINFO_REMOVE](state, arr) {
    state.userInfo = {}
  },
  [TYPES.RESOURCE_UPDATE](state, payload) {
    state.menus = payload.menus
    state.btns = payload.btns
    state.allFuncs = payload.allFuncs
  },
  [TYPES.RESOURCE_REMOVE](state, payload) {
    state.menus = {}
    state.btns = {}
    state.allFuncs = {}
  },
  //主题
  [TYPES.THEME_UPDATE](state, payload) {
    state.themeName = payload
  },
  // 是否解码
  [TYPES.DECODE_UPDATE](state, payload) {
    state.decodeValue = payload
  },
  [TYPES.NEW_CONTENT_ALERT](state, payload) {
    state.newContentAlert = payload
  }
}
